import * as React from "react"
import type { SVGProps } from "react"
const SvgUploadFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 17.57V14.4l-.87.87q-.3.3-.7.29a1 1 0 0 1-.7-.29 1 1 0 0 1-.32-.7 1 1 0 0 1 .29-.7l2.6-2.6q.14-.15.33-.21a1 1 0 0 1 .74 0 1 1 0 0 1 .33.21l2.6 2.6q.3.3.29.7t-.29.7a1 1 0 0 1-.69.31 1 1 0 0 1-.37-.06 1 1 0 0 1-.34-.22l-.9-.9v3.17q0 .43-.29.71a1 1 0 0 1-.71.3 1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7" />
    <path
      fillRule="evenodd"
      d="M4.59 21.98q.59.6 1.41.6h12q.83 0 1.41-.6.6-.59.59-1.4V9.4a2 2 0 0 0-.57-1.4l-4.85-4.85a2 2 0 0 0-1.4-.58H6q-.82 0-1.41.59A2 2 0 0 0 4 4.57v16q0 .82.59 1.41M13 4.57v4q0 .42.29.71.29.3.71.29h4v11H6v-16z"
    />
  </svg>
)
export default SvgUploadFile
